import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { UserPreferencesProvider } from './contexts/UserPreferencesContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <UserPreferencesProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </UserPreferencesProvider>
  </React.StrictMode>
);
